<template>
  <div>
    <div v-for="mode in allModes" :key="mode" class="radio styled">
      <input
        :id="`mode_${mode}`"
        type="radio"
        name="mode"
        :value="mode"
        :checked="selectedMode === mode"
        :disabled="!isAvailable(mode)"
        @change="$emit('selected', mode)"
      />
      <label :for="`mode_${mode}`">
        <div :class="{ mbs: true, disabled: !isAvailable(mode) }">
          <p class="show mbs">
            <b>{{ lang.get('score-set.modes.' + mode) }}</b>
            <help-icon
              v-if="!isAvailable(mode)"
              :content="lang.get('features.not_available')"
            />
          </p>
          <p class="show">
            {{ lang.get(`panels.modes.${mode}.description`) }}
          </p>
        </div>
      </label>
      <slot :name="'details:' + mode"></slot>
    </div>
  </div>
</template>

<script>
import HelpIcon from '@/lib/components/Shared/HelpIcon';

export default {
  inject: ['lang'],
  components: {
    HelpIcon
  },
  model: {
    prop: 'selectedMode',
    event: 'selected'
  },
  props: {
    allModes: {
      type: Array,
      required: true
    },
    availableModes: {
      type: Array,
      required: true
    },
    selectedMode: {
      type: String,
      default: ''
    },
    showInput: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    isAvailable(mode) {
      return this.availableModes.includes(mode);
    }
  }
};
</script>
